// extracted by mini-css-extract-plugin
export default {"root":"OrderInfo-root-a8c0","head":"OrderInfo-head-aea4","date":"OrderInfo-date-e999"};